import { resultsCollection } from "utils/fire";

export const getTestResultById = async (id) => {
	const result = await resultsCollection.doc(id).get();
	const data = result.data();

	return data;
};
